var map = {
	"./adviters.png": 4691,
	"./allianz.png": 9367,
	"./errepar.png": 1768,
	"./ferrere.png": 4656,
	"./intermedia.png": 2186,
	"./itbc.png": 6061,
	"./swiss-medical.png": 1865,
	"./tisa.png": 2120
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9066;